import { StammdatenService } from '../../../../../services/stammdaten.service';
import { Component, inject, Input, OnInit } from '@angular/core';
import { StateService } from '@/core/services/state.service';
import { BankdataDisplayModelFormGroup } from '@/api/model-index';
import { IbanValidator } from '@/core/validators/iban-validator';
import { BICValidator } from '@/core/validators/bic-validator';
import { TextBoxService } from '@/core/services/textbox.service';
import { Validators } from '@angular/forms';
import { I18nService } from '@/core/services/i18nService';
import { formatBic, formatIban } from '@/core/utils/bankdata-utils';

@Component({
    selector: 'bank-data',
    templateUrl: './bank-data.component.html',
    styleUrls: ['./bank-data.component.scss'],
    standalone: false
})
export class BankDataComponent implements OnInit {
  @Input("form") public bankDataForm: BankdataDisplayModelFormGroup;
  @Input("required") public required: boolean = false;

  protected translateService = inject(I18nService);

  constructor(protected stateService: StateService, protected stammdatenService: StammdatenService, protected textBoxService: TextBoxService) {
  }

  ngOnInit(): void {


    this.stammdatenService.GetPortalKonfiguration().subscribe(cfg => {
      if (cfg != undefined && cfg.ibanueberpruefung == true) {
        this.bankDataForm.Iban.addValidators([new IbanValidator(cfg).validate]);
        this.bankDataForm.Bic.addValidators([new BICValidator(cfg).validate]);
      }
    });

    if (this.stateService.IsEndvalidationEnabled) {
      if (this.required) {
        this.bankDataForm.Iban.addValidators([Validators.required]);
        this.bankDataForm.Bic.addValidators([Validators.required]);
        this.bankDataForm.Kontoinhaber.addValidators([Validators.required]);
        this.bankDataForm.NameDesKreditInstituts.addValidators([Validators.required]);
      }
      this.bankDataForm.markAllAsTouched();
    }

    // used to bubble the value changes to the top form value
    this.bankDataForm.valueChanges.subscribe(change => {
      var change = change;
    });

    this.bankDataForm.Iban.setValue(formatIban(this.bankDataForm.Iban.value));
  }

  public appendAsteriskIfRequired(label: string): string {
    return this.required ? label + " *" : label;
  }

  get ibanErrorMessage(): string {
    if (this.bankDataForm.Iban?.errors?.isIbanValid === false)
      return this.translateService.instant('bank-data.iban.invalid');

    return "";
  }

  get bicErrorMessage(): string {
    if (this.bankDataForm.Bic?.errors?.isBICValid === false)
      return this.translateService.instant('bank-data.bic.invalid');

    return "";
  }

  onIbanInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    //needed to manage cursor position
    const cursorlocation = input.selectionStart ?? 0;
    const oldLength = input.value.length;
    //format the IBAN
    const formatted = formatIban(input.value);
    this.bankDataForm.Iban.setValue(formatted, { emitEvent: false });
    //get new cursor position after formatting
    const diff = formatted.length - oldLength;
    let newCursorLocation = cursorlocation + diff;
    newCursorLocation = Math.max(0, Math.min(newCursorLocation, formatted.length));
    setTimeout(() => {
      // set the cursor position after the next change detection cycle to be where it was before formatting
      input.setSelectionRange(newCursorLocation, newCursorLocation);
    });
  }

  onBicInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    //needed to manage cursor position
    const cursorlocation = input.selectionStart ?? 0;
    const oldLength = input.value.length;
    //format the BIC
    const formatted = formatBic(input.value);
    this.bankDataForm.Bic.setValue(formatted, { emitEvent: false });
    //get new cursor position after formatting
    const diff = formatted.length - oldLength;
    let newCursorLocation = cursorlocation + diff;
    newCursorLocation = Math.max(0, Math.min(newCursorLocation, formatted.length));
    setTimeout(() => {
      // set the cursor position after the next change detection cycle to be where it was before formatting
      input.setSelectionRange(newCursorLocation, newCursorLocation);
    });
  }
}
